/*
 * Norrviva — FAQ accordion.
 *
 * The native <details>/<summary> rows open and close on their own; this
 * script only enforces "one open at a time" within each [data-faq-accordion]
 * group. Mirrors initAccordion() in norrviva-pdp.js. Progressive: with JS
 * off, the rows still open and close, they just don't auto-collapse.
 */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function initGroup(group) {
    var rows = group.querySelectorAll('details.nvv-pdp__acc-row');
    rows.forEach(function (row) {
      row.addEventListener('toggle', function () {
        if (!row.open) return;
        rows.forEach(function (other) {
          if (other !== row && other.open) other.open = false;
        });
      });
    });
  }

  ready(function () {
    document.querySelectorAll('[data-faq-accordion]').forEach(initGroup);
  });
})();
